import { render, staticRenderFns } from "./productIntroductionTemplateGroupEdit.vue?vue&type=template&id=97b2c674&scoped=true"
import script from "./productIntroductionTemplateGroupEdit.vue?vue&type=script&lang=js"
export * from "./productIntroductionTemplateGroupEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b2c674",
  null
  
)

export default component.exports